export default {
  'marketplace.action-msg.generate-label-success': 'Generate to Label successfully',
  'marketplace.action-msg.ack-order-success': 'Acknowledge marketplace order successful',
  'marketplace.action-msg.cancel-order-success': 'Cancel fulfillment order successful',
  'marketplace.action-msg.sync-order-success': 'Sync platform order successful',
  'marketplace.order.tab.all_platform_order': 'Platform Order (All)',
  'marketplace.order.tab.fulfillment_order': 'Fulfillment Order',
  'marketplace.order.tab.fulfillment_order_tooltips': 'OMS Accepted Platform Order',
  'marketplace.order.tab.fulfillment_request': 'Fulfillment Request',
  'marketplace.order.tab.wms_pre_order': 'WMS Pre Order',
  'marketplace.order.tab.wms_accepted': 'WMS Accepted',
  'marketplace.order.tab.upload_order': 'Upload Order',
  'marketplace.order.tab.upload_order-for': 'Upload Order (For Create Label)上傳訂單(用於建立標籤)',
  'marketplace.order.tab.rejected_label': 'Rejected Label',
  'marketplace.order.tab.ready_to_ship': 'Ready To Ship(Label)',
  'marketplace.order.tab.packed_order': 'Packed Order',
  'marketplace.order.tab.shipped_order': 'Shipped Order',
  'marketplace.order.id': 'ID',
  'marketplace.order.store_account': 'Store Account',
  'marketplace.order.title': 'Marketplace Order List',
  'marketplace.order.platform': 'Platform',
  'marketplace.order.platform_order_id': 'Platform Order ID',
  'marketplace.order.platform_order_no': 'Platform Order No.',
  'marketplace.order.platform_fulfillment_order_id': 'Platform Fulfillment Order ID',
  'marketplace.order.sync_platform_order_button': 'Sync Platform Orders',
  'marketplace.order.sync_order_date': 'Sync Order Date',
  'marketplace.button.show_marketplace_order_fulfillment_detail': 'Show New Order Detail',
  'marketplace.button.edit_shipping_button': 'Update Shipping Address',
  'marketplace.order.new_platform_fulfillment_title': 'New Order Detail',
  'marketplace.order.update_shipping_address': 'Update Order #{platformOrderId} Shipping Address',
  'marketplace.order.update-shipping-address.fail': 'Update shipping address failed',
  'marketplace.order.push_wms_success': 'Push WMS Success',
  'marketplace.order.push_wms_failed': 'Push WMS Failed',
  'marketplace.order.push_generate_waybill_success': 'Push Success',
  'marketplace.order.push_generate_waybill_failed': 'Push Failed',
  'marketplace.order.purchase_date': 'Purchase Date',
  'marketplace.order.latest_pickup_date': 'Pickup Date',
  'marketplace.order.purchase_date_from': 'From Purchase Date',
  'marketplace.order.currency': 'Currency',
  'marketplace.order.number_of_sku_qty': 'Total Ordered Qty',
  'marketplace.order.fulfillment_location_name': 'Fulfillment Location',
  'marketplace.order.platform_fulfillment_status': 'Platform Fulfillment',
  'marketplace.order.platform_payment_status': 'Platform Payment',
  'marketplace.order.platform_order_status': 'Platform Order Status',
  'marketplace.order.total_commission': 'Total Commission',
  'marketplace.order.label_status': 'Label Status',
  'marketplace.order.download-all-to-label': 'Download All',
  'marketplace.order.status': 'Status',
  'marketplace.order.basic-info': 'Basic Information',
  'marketplace.order.marketplace_store': 'Marketplace Store',
  'marketplace.order.total_amount': 'Total Amount',
  'marketplace.order.shipping_fee': 'Shipping Fee',
  'marketplace.order.shipping_fee_original': 'Shipping Fee original',
  'marketplace.order.shipping_fee_discount': 'Shipping Fee Discount',
  'marketplace.order.total_tax': 'Total Tax',
  'marketplace.order.voucher_amount': 'Voucher Amount',
  'marketplace.order.voucher_platform': 'Voucher Platform',
  'marketplace.order.voucher_seller': 'Voucher Seller',
  'marketplace.order.payment_method': 'Payment Method',
  'marketplace.order.buyer_note': 'Buyer Note',
  'marketplace.order.gift_option': 'Gift Option',
  'marketplace.order.remark': 'Remark',
  'marketplace.order.bill-info': 'Billing Information',
  'marketplace.order.bill_name': 'Bill Name ',
  'marketplace.order.bill_phone': 'Bill Phones Number',
  'marketplace.order.bill_postal_code': 'Bill Postal Code ',
  'marketplace.order.bill_country': 'Bill Country',
  'marketplace.order.bill_city': 'Bill City',
  'marketplace.order.bill_district': 'Bill District',
  'marketplace.order.bill_address': 'Bill Address',
  'marketplace.order.shipping-info': 'Shipping Information',
  'marketplace.order.shipping_name': 'Shipping Name',
  'marketplace.order.shipping_phone': 'Shipping Phones Number',
  'marketplace.order.shipping_postal_code': 'Shipping Postal Code',
  'marketplace.order.shipping_country': 'Shipping Country ',
  'marketplace.order.shipping_city': 'Shipping City',
  'marketplace.order.shipping_district': 'Shipping District',
  'marketplace.order.shipping_address': 'Shipping Address',
  'marketplace.order.order_item_id': 'Order Item Id',
  'marketplace.order.product_name': 'Product Name',
  'marketplace.order.seller_sku': 'Seller SKU',
  'marketplace.order.quantity_ordered': 'Quantity Ordered',
  'marketplace.order.shipping_type': 'Shipping Type',
  'marketplace.order.unit_price': 'Unit Price',
  'marketplace.order.item_price': 'Items Price',
  'marketplace.order.require_fulfillment_qty': 'Require Fulfillment Qty',
  'marketplace.order.fulfillment_qty': 'Fulfillment Qty',
  'marketplace.order.weight': 'Weight',
  'marketplace.order.country_of_origin': 'Country Of Origin',
  'marketplace.order.item_declared_value': 'Item Declared Value',
  'marketplace.order.hscode': 'HS Code',
  'marketplace.order.shipping_price': 'Shipping Price',
  'marketplace.order.item-info': 'Order Item Details',
  'marketplace.order.detail.title': 'Order ',
  'marketplace.order.to_country': 'To Country',
  'marketplace.order.declared_value': 'Declared Value',
  'marketplace.order.sync_orders': 'Sync Platform Orders',
  'marketplace.order.sync_orders.tooltip': 'Sync Platform Orders',
  'marketplace.order.button.sync_orders': 'Sync Platform Orders',
  'marketplace.order.item.no': 'No.',
  'marketplace.order.weight.tooltip': 'Weight Unit (G)',
  'marketplace.order.item_declared_value.tooltip': 'Declared Value (Per Item)',
  'marketplace.order.create_label_success_title':
    'Create shipment label successfully, Please check',
  'marketplace.order.create_shipment.title': 'Create Order {document_no} Shipment Label',
  'marketplace.order.re_create_shipment.title': 'Re-Generate Order {document_no} Shipment Label',
  'marketplace.order.edit_shipment.title': 'Edit Order {document_no} Shipment Label',
  'marketplace.button.create_label': 'Create Shipment Label',
  'marketplace.order.create_label.fail': 'Create shipment label failed, please check',
  'marketplace.order.create_label.success': 'Create shipment label successfully, please check',
  'marketplace.order.shipped.success': 'Shipped order successfully',
  'marketplace.order.dispatch-shipping-confirm': 'Are you sure you want to ship selected orders?',
  'marketplace.order.print_picklist_label': 'Print Picklist',
  'marketplace.order.mark_as_shipped_orders': 'Mark As Shipped',
  'fulfillment.order.shipped_success': 'Shipped Success',
  'fulfillment.order.shipped_failed': 'Shipped Failed',
  'marketplace.button.send_to_wms': 'Send To WMS',
  'marketplace.order.send-to-wms-confirm':
    'Are you sure you want to send selected fulfillment order to WMS?',
  'marketplace.tooltip.acknowledge-order': 'Acknowledge Platform Order',
  'marketplace.acknowledge-order-confirm': 'Are you sure you want to acknowledge this order?',
  'marketplace.order.shipment-info': 'Order Shipment',
  'marketplace.order.shipment_reference_no': 'Shipment Ref No.',
  'marketplace.order.service_code': 'Service Code',
  'marketplace.order.incoterm': 'Incoterm',
  'marketplace.order.shipment_content': 'Shipment Content',
  'marketplace.order.tracking_no': 'Tracking No.',
  'marketplace.order.delivery_email': 'Delivery E-mail',
  'marketplace.order.delivery_name': 'Delivery Name',
  'marketplace.order.delivery_company': 'Delivery Company',
  'marketplace.order.delivery_address': 'Delivery Address',
  'marketplace.order.delivery_state': 'Delivery State',
  'marketplace.order.delivery_postal': 'Delivery Postal',
  'marketplace.order.delivery_country': 'Delivery Country',
  'marketplace.order.delivery_phone': 'Delivery Phone',
  'marketplace.order.delivery_city': 'Delivery Address',
  'marketplace.order.packed_at': 'Packed At',
  'marketplace.order.shipped_at': 'Shipped At',
  'marketplace.button.re_create_label': 'Re-Generate Shipment Label',
  'marketplace.order.shipment_by_system': 'Create Shipment By',
  'marketplace.sync-shipping': 'Sync Shipping Info',
  'marketplace.sync-shipping-info-confirm': 'Are you sure you want to sync order shipping info?',
  'marketplace.order.external_fulfillment_status': 'External Fulfill Status',
  'marketplace.upload-order.instruction-1':
    '*Successfully created shipment data here will be automatically stored in Shipment Summary.',
  'marketplace.upload-order.instruction-2':
    '*Suggest to upload maximum 250 lines of data for each batch.',
  'marketplace.upload-order.instruction-3':
    '*Data Format Requirements: Please ensure the uploaded file meets the data format requirements of the system. Refer to the template provided by the system for specific format guidelines',
  'marketplace.upload-order.instruction-4':
    '*For huge data upload, please contact our customer service hotline: 2648 8902.',
  'marketplace.order.fulfillment_wms_title': 'Fulfilment Selected Order By WMS',
  'marketplace.order.fulfillment_title': 'Fulfilment Request',
  'marketplace.order.fulfillment-to-wms-outbound': 'Fulfilment By WMS',
  'marketplaces.common.select-order-first': 'Please select the new orders to download',
  'marketplace.order.fulfillment-to-generate-waybill': 'Generate Waybill',
  'marketplace.order.fulfillment_generate_waybill_title': 'Fulfill orders by yourself',
  'marketplace.download_selected_oms_accepted': 'Download Selected OMS Accepted',
  'marketplace.order.create_multi_piece_button': 'Multi-piece shipments',
  'marketplace.order.create_one_piece_button': 'One-piece shipments',
  'marketplace.order.boxed_qty': 'In Package Qty',
  'marketplace.order.total_ordered_quantity': 'Total Ordered Qty',
  'marketplace.order.total_item_price': 'Total Price',
  'marketplace.order.subtotal': 'Subtotal',
  'marketplace.order.voucher_amount': 'Voucher Amount',
  'marketplace.order.net_item_value': 'Net Item Value',
  'marketplaces.oms_accepted.selected_different_hk_country':
    'the local orders can not be selected together with other country',
  'fulfillment.order.packages-item-info': 'Packages Details',
  'fulfillment.order.shipment_reference_no': 'Fulfillment Ref No.',
  'fulfillment.order.courier_service_code': 'Service Code',
  'fulfillment.order.sku': 'SKU',
  'fulfillment.order.product_name': 'Product Name',
  'fulfillment.order.quantity': 'Quantity',
  'fulfillment.order.wms_merchant_code': 'WMS Merchant Code',
  'fulfillment.order.wms_warehouse_code': 'WMS Warehouse',
  'fulfillment.order.wms_delivery_note_code': 'WMS Delivery Note',
  'fulfillment.order.show_fulfillment_detail': 'Show Fulfillment Order Details',
  'fulfillment.order.no-available-item-to-add-new-package':
    'There is no available item to add new package',
  'fulfillment.order.add-new-package-button': 'Add New Package',
  'fulfillment.order.cancel-confirm': 'Are you sure to cancel this {document_no} fulfilment order?',
  'fulfillment.order.request_pickup_date': 'Request Pickup Date',
  'fulfillment.order.ready_to_ship_date_at': 'Ready To Ship Date At',
  'fulfillment.order.shipped_date_at': 'Shipped Date At',
  'fulfillment.order.platform_transporter': 'Platform Transporter',
  'fulfillment.order.tracking_url': 'Tracking URL',
  'fulfillment.order.error_message': 'Error Message',
  'fulfillment.order.subtotal': 'SubTotal',
  'fulfillment.order.total_quantity': 'Total Quantity',
  'fulfillment.order.total_weight': 'Total Weight',
  'fulfillment.order.total_declared_value': 'Total Declared Value',
  'fulfillment.order.outbound_strategy': 'Outbound Strategy',
  'fulfillment.order.pending_to_ready_button': 'Choose Outbound Strategy',
  'fulfillment.order.fulfillment_pending_to_ready_title': 'Choose Outbound Strategy',
  'fulfillment.order.outbound_type_wms': 'Outbound By WMS',
  'fulfillment.order.outbound_type_label': 'Only Download Waybill',
  'fulfillment.order.multi_piece_basic_title': 'Basic Info',
  'fulfillment.order.multi_piece_pacakge_title': 'Multi Packages Info',
  'fulfillment.order.send_to_wms.success': 'Send To WMS Successfully',
  'fulfillment.request.button.download_waybill': 'Download Waybill',
  'fulfillment.order.oms_order_reference': 'OMS Order Reference',
  'fulfillment.order.item.oms_po_reference': 'PO Reference',
  'fulfillment.order.oms_order_type': 'OMS Order Type',
  'fulfillment.order.external_sap_status': 'External SAP Status',
  'fulfillment.request.external_status': 'External WMS Status',
  'fulfillment.button.send-sap-order': 'Send To SAP',
  'fulfillment.order.send-sap-order-confirm': 'Are you sure to send this {document_no} fulfilment order to SAP?',
  'fulfillment.button.send-wms-label': 'Send To WMS Waybill',
  'fulfillment.request.send-wms-label-confirm': 'Are you sure to send this {document_no} waybill to External WMS?',
  'fulfillment.button.cancel-stock-order': 'Cancel OMS Stock',
  'fulfillment.order.cancel-stock-order-confirm': 'Are you sure to cancel the OMS stock for the platform order {document_no}?',
  'fulfillment.button.allocated-stock-label': 'Allocate OMS Stock',
  'fulfillment.order.allocated-stock-order-confirm': 'Are you sure to allocate the OMS stock for the platform order {document_no}?',
  'fulfillment.order.oms_cancel_flow': 'Cancel Flow',
  'fulfillment.order.oms_cancel_status': 'OMS Cancel Status',
  'order.step.new_order_at': 'New',
  'order.step.oms_accepted_at': 'OMS Accepted',
  'order.step.send_to_sap_at': 'Send TO SAP',
  'order.step.send_to_wms_label_at': 'Send Waybill To WMS',
  'order.step.packed_at': 'Packed At',
  'order.step.client_ready_to_ship_at': 'Ready To Ship (SAP)',
  'order.step.client_request_cancel_at': 'Exception (SAP)',
  'order.step.wms_shipped_at': 'Shipped',
  'order.step.delivered_at': 'Delivered',
};
